import {React, useEffect} from "react";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";
import ButtonLink from "./ButtonLink";

import { Helmet } from "react-helmet";
import Header from "../img/mediapipe-neuro_thumb_upscale.png";

import TFJSdemo1 from "../video/TFdemo_1.mp4";
import TFJSdemo3 from "../video/TFdemo_3.mp4";
import TFJSdemo4 from "../video/TFdemo_4.mp4";
import TFJSdemo6 from "../video/TFdemo_6.mp4";

import MediapipeDemo1 from "../img/mediapipe1_demo.gif";
import MediapipeDemo2 from "../img/mediapipe2_demo.gif";
import MediapipeDemo3 from "../img/mediapipe3_demo.gif";

import BrainDICOM from "../img/brain_DICOM.gif";
import BrainWIP from "../img/brain WIP.PNG";




function MediapipeNeuro() {

  // useEffect(() => {
  //   document.title = "ETCHNG | Using machine learning to create a gesture-controlled neuroanatomy atlas";  
  
  // }, [])

  return (
    <>

<Helmet>
        <title>ETCHNG | Using machine learning to create a gesture-controlled neuroanatomy atlas</title>
        <meta name="description" content="Mediapipe neuroanatomy application"/> 
        <meta name="keywords" content="ETCHNG, Eric Chung, medical illustrator, Mediapipe, Neuroanatomy, Machine learning, Tensorflow.js, Three.js, Mediapipe, Web app, UI/UX, 3D, Blender, ZBrush, HTML/CSS/JS"
        />
    </Helmet>
      <HeroHeader
        hero_img={Header}
        // video = {Header}
        type="Web app —"
        name="Using machine learning to create a gesture-controlled neuroanatomy atlas        "
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
              <div className='work__info__basic__item'> <h5>Date</h5>
                  <p>Mar 2022 - Sept 2022 </p> </div>
                  <div className='work__info__basic__item'>    <h5>Role</h5>
                  <p>UI/UX designer, 3D artist, web developer</p></div>
                  <div className='work__info__basic__item'> <h5>Tools</h5>
                  <p>HTML/CSS/JS (Three.JS, TensorFlow.JS, Mediapipe), Blender, ZBrush</p></div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p>This was an exercise in leveraging the machine learning library Tensorflow.JS in conjunction Mediapipe's Hands computer vision model to emulate spatial computing interactions, such as those in VR and LeapMotion, in the browser using only standard webcam RGB video input.</p>

<p>Conceptually, this was inspired by my experience with cadaver dissections, as well as the early popularity of LeapMotion sensors in the medical field, to avoid having to physically touch an object (textbook, screen, mouse, etc.) to interact with it.</p>
<br/>
              <div className="btn__wrap">
                <a href="https://etchng.github.io/mediapipe-neuro/" target="_blank" rel="noreferrer">
                  <ButtonLink> View Demo</ButtonLink>
                </a>
              </div>
            </div>

            
          </div>
          <div className="work">
              <div className="work__info twoColumn">
                <h4>CHALLENGE</h4>
              </div>
              <div className="work__info twoColumn">
              <p>
              In conventional 3D applications, navigation is limited to 2D input using mouse and keyboard, despite scenes having 3D coordinates. While not an issue for scenes with sparsely-distributed objects, this creates a navigational challenge for the opposite scenario. It results in objects occluding each other, making it difficult for users to interact with and understand spatial relationships of structures. 


            </p>

            <p>
            In addition, the use of input devices such as a mouse and keyboard can be cumbersome and inefficient for tasks that require frequent switching between different tools. This is particularly relevant in contexts such as dissection or surgery, due to contimination concerns.
            </p>

              </div>
            </div>

          
        <div className="work">

          <div className="work__info narrowColumn">
            <h4>PROTOTYPING</h4>

            <p>
           I experimented with older, more abstracted computer vision libraries, such as Handtrack.JS, which provides a simple API for hand and face tracking, as well as pre-defined gesture detection. While I was able to map the screen space coordinates of the input video to world space for the WebGL scene, the library is limited to only one hand at a time, and I also wanted lower-level access for further customization. 
           </p>
                  


          </div>
          <div className="work__info wideColumn">
          <video loop autoPlay controls width="540">
    <source src={TFJSdemo1} loading="lazy" type="video/mp4"/>
    Your browser does not support the video tag.
  </video>
       

          </div>

        </div>
        <div className="work reverse">
 <div className="work__info wideColumn">
         
          <video loop autoPlay controls width="540">
    <source src={TFJSdemo3} loading="lazy" type="video/mp4"/>
    Your browser does not support the video tag.
  </video>

          </div>
          <div className="work__info narrowColumn">

      
            <p>
           I also experimented with the native Tensorflow.JS Handpose model, which which is more robust, but requires more complex setup and processing. It allowed me to access the keypoints' coordinates more easily, and map 3D visualizations to them.

            </p>
         


          </div>
         

        </div>

<div className="work">

          <div className="work__info narrowColumn">

            <p>
           I experimented with older, more abstracted computer vision libraries, such as Handtrack.JS, which provides a simple API for hand and face tracking, as well as pre-defined gesture detection. While I was able to map the screen space coordinates of the input video to world space for the WebGL scene, the library is limited to only one hand at a time, and I also wanted lower-level access for further customization. 
           </p>
                  


          </div>
          <div className="work__info wideColumn">
          <video loop autoPlay controls width="540">
    <source src={TFJSdemo4} loading="lazy" type="video/mp4"/>
    Your browser does not support the video tag.
  </video>
       

          </div>

        </div>
        <div className="work reverse">
 <div className="work__info wideColumn">
         
 <video loop autoPlay controls width="540">
    <source src={TFJSdemo6} loading="lazy" type="video/mp4"/>
    Your browser does not support the video tag.
  </video>


          </div>
          <div className="work__info narrowColumn">

      
          <p>
  As I refined the prototypes and model, it became increasingly apparent that allowing for 2-handed interaction would be more intuitive, ergonomical and allow for more complex interactions. </p>

<p>In particular, it was common practice in anatomy to pierce a structure at a given point with a rod or probe, and be able to identify it as well as the surrounding structures that had also been pierced in the appropriate order. This could be most readily replicated be using a 2-handed gesture for the two endpoints of the selection, similar to in VR.
  
</p>

<p>This provided a firm direction to change from the native Tensorflow.JS Handpose model, to the more advanced Mediapipe library, which allows for higher fidelity hand tracking, and allows for 2-handed interaction. This also resolved some of the jittering associated with the previous models.
  </p>
         


          </div>
         

        </div>

        {/* <div className="work">
          <p>
            I also created brief personas based on my proposed target users.

          </p> </div>  */}
          <div className="work">
          <div className="work__info narrowColumn">
<h4>BRAIN MODEL</h4>
<p>
  Using T1-weighted MRI data from the Human Connectome Project, I created a 3D model of the brain using Blender. I then used ZBrush to create a high-resolution texture map for the model.
</p>
          <img src={BrainDICOM} loading="lazy"
            alt="Primary persona of Curious George. Personality and characteristics include: Technology savvy and regularly likes to track analytics, 	Likes to dive deep into information, and Outdoors and fitness enthusiast."></img>
                   
          
         </div><div className="work__info wideColumn">

          <img src={BrainWIP} loading="lazy"
            alt="Secondary persona of Casual Carly. Personality and characteristics include: comfortable with technology, limited science background, and likes a good story."></img>
            <p> This custom modeling was done so the brain would correspond as accurately as possible to the MRI data, and to allow for more detailed visualizations of the brain's anatomy.</p>
        </div>
        </div>
        

        <div className="work">

          <div className="work__info narrowColumn">

            <p>
           To allow for a high degree of granularity when selecting structures, the model was split into 120 meshes based on DKT cortical regions, white matter, and subcortical structures. All sections are solid and manifold.

            </p>
          </div>

          <div className="work__info wideColumn">

          <iframe className="youtube" height="515" src="https://www.youtube.com/embed/thoRVn8WPik"
    title="YouTube video player" frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen></iframe> 

          </div>

        </div>

        
     
        
        <div className="work">



          {/* <div className="work__info narrowColumn">
            <h4>DESIGN</h4>



          </div> */}
        </div>
        <div className="work">
          <div className="work__info narrowColumn">

          <h4>DESIGN</h4>
<p>The final application allows users to navigate using gestures from both hands, in both 2D and 3D space. A clipping plane function allows users to create a cross-sectional view of the brain in the saggital, coronal, and transverse planes, while the MRI view is available on the right side and corresponds to the location of the clipping planes. It is intended for desktop use (ideally 16in+ display), where the user is positioned approximately 1m from the webcam.</p>
          </div>
          <div className="work__info wideColumn">

           <iframe className="youtube" height="515" src="https://www.youtube.com/embed/Q6EVR0DvRWc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>


        </div>

        <div className="work"> <div className="work__info wideColumn">

            <div className="work__info">


         
              <img src={MediapipeDemo1} loading="lazy" alt="Demo of the user rotating the brain model and selecting structures using hand gestures."></img>

            </div>
          </div>
          <div className="work__info narrowColumn">

              <p>Users can rotate the model with a closed wiping hand gesture, and select structures by 'touching' them with their index finger. The model will then highlight the selected structure, and display the name of the structure in the centre box in the bottom grid. Doing so will also drop a 'pin' in the area of selection, which is also represented in the MRI view; this is meant to be leverage anatomy lab conventions for marking a structure to help indicate the selection in the MRI. The bottom grid provides contextual information for the structures that immediately surround the selected structure. 
              </p>
             
             <p>A horned hands gesture deselects all structures.</p>

          </div>
         
        </div>

        <div className="work">

          <div className="work__info narrowColumn">
            <p>
          By using both hands, the user can select a series of structures. This is also visualized by a line the two selection endpoints, which is also reflected in the MRI views. This switches the bottom grid to a list view, with the structures order from left to right hand.
            </p>

          </div>
          <div className="work__info wideColumn">
            <img src={MediapipeDemo2} loading="lazy" alt="Demo of scrolling experience."></img>

          </div>
        </div>
        <div className="work">
          <div className="work__info wideColumn">
            <img src={MediapipeDemo3} loading="lazy" alt="Demo of scrolling experience."></img>

          </div>
          <div className="work__info narrowColumn">
            <p>
           Users are able to toggle between a clipping mode, allowing them to specify which of the layers (cortical, white matter, subcortical) should be clipped, as well as general layer visibility.
            </p>

          </div>

        </div>

      
        
       

    
        

        <div className="work">
          <div className="work__info twoColumn">
            <h4> NEXT STEPS</h4>

            <p>While this proof of concept is not intended for production, these would be some of the priority items that would benefit from future improvements.</p>
          </div>

          <div className="work__info"  id="twoColumn">

            <ul>
              <li>
                <b>Optimization</b>
                <p>
                 While the model itself has been relatively optimized, the application is still quite resource intensive, particularly during 2-hand selection. This is due to the fact that the model has been segmented into 120 meshes, increasing the memory usage, and the raycasting operation used for selection is computationally expensive. 
                </p>
              </li>
              <li>
                <b>Refined selection control</b>
                <p>
                  
                  Selection is currently done by raycasting to the surface of a lower-poly proxy object. This is a relatively simple solution, but it does not allow for fine-grained control of selection, particularly when the user is in the hollow part of the structure.
                </p>
              </li>
              <li>
                <b>Clipping plane intersection visualization</b>
                <p>
                 The clipping planes were intentionally designed to be hollow to be unobtrusive, but this also makes it difficult to visualize the intersection of the clipping plane with the model. This could be addressed by creating a custom shader for the structures that would visualize the intersection.
                </p>
              </li>
            </ul>
          </div>
          </div> 
        </div>

        <ContactCTA />
      </div>
    </>
  );
}

export default MediapipeNeuro;
